import type { IntlShape } from 'react-intl'
import type {
	ReportFormData,
	ReportListItem,
} from 'ui/ManagerFinance/ReportingBase/types'

export const reportForms: Record<string, ReportFormData> = {
	purchaseInvoiceList: {
		type: 'chart-of-purchase-invoices',
		preferredFormat: 'pdf',
		supportedFormats: ['pdf', 'xls'],
		formInputs: [],
	},
	openPurchaseInvoices: {
		type: 'open-purchase-invoices',
		preferredFormat: 'pdf',
		supportedFormats: ['pdf', 'xls'],
		formInputs: [],
	},
	overduePurchaseInvoices: {
		type: 'overdue-purchase-invoices',
		preferredFormat: 'pdf',
		supportedFormats: ['pdf', 'xls'],
		formInputs: [],
	},
}

export const reportItems: ReportListItem[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Avoimet ostolaskut',
				description: 'Open purchase invoices',
			}),
		description: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage:
					'Avoimet ostolaskut-raportti on nimensä mukaisesti yksinkertainen listaus avoimista ostolaskuista.',
				description: 'Open purchase invoices description',
			}),
		key: 'openPurchaseInvoices',
		icon: 'description',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Erääntyneet ostolaskut',
				description: 'Overdue purchase invoices',
			}),
		description: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage:
					'Erääntyneet ostolaskut-raportti on nimensä mukaisesti yksinkertainen listaus erääntyneistä ostolaskuista.',
				description: 'Overdue purchase invoices description',
			}),
		key: 'overduePurchaseInvoices',
		icon: 'description',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Ostolaskuluettelo',
				description: 'Purchase invoice list',
			}),
		description: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Luettelo ostolaskuista.',
				description: 'Purchase invoice list description',
			}),
		key: 'purchaseInvoiceList',
		icon: 'description',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Maksuennuste luettelo',
				description: 'Payment forecast list',
			}),
		description: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage:
					'Maksuennuste luettelosta näet tiedot laskuista, joiden eräpäivä on lähestymässä.',
				description: 'Payment forecast description',
			}),
		key: 'paymentForecastList',
		icon: 'description',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Toimittajatilasto',
				description: 'upplier statistics',
			}),
		description: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage:
					'Toimittajatilastosta löydät ostolaskut toimittajittain ryhmiteltynä.',
				description: 'Supplier statistics description',
			}),
		key: 'supplierStatistics',
		icon: 'description',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Maksuluettelo',
				description: 'Payment list',
			}),
		description: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage:
					'Maksuluettelo-raportti listaa maksut ja ostolaskut joihin suoritukset kuuluvat.',
				description: 'Payment list description',
			}),
		key: 'paymentListPurchases',
		icon: 'description',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Maksujen tiliöinti',
				description: 'Posting of payments',
			}),
		description: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage:
					'Maksujen tiliöinti-raportti erittelee tositteiden maksut tileittäin.',
				description: 'Posting of payments description',
			}),
		key: 'paymentPostings',
		icon: 'description',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tiliöintiyhteenveto: Maksut',
				description: 'Posting summary – payments',
			}),
		description: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage:
					'Tiliöintiyhteenveto, maksut -raportti tekee yhteenvedon maksuissa käytetyistä tileistä.',
				description: 'Posting summary payments description',
			}),
		key: 'postingSummaryPayments',
		icon: 'description',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Ostojen tiliöinti',
				description: 'Posting of purchases',
			}),
		description: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage:
					'Ostojen tiliöinti-raportti erittelee ostolaskuissa käytetyt tilit laskuittain.',
				description: 'Posting of purchases description',
			}),
		key: 'purchasePostings',
		icon: 'description',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tiliöintiyhteenveto: Ostot',
				description: 'Posting summary – purchases',
			}),
		description: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage:
					'Tiliöintiyhteenveto, ostot -raportti tekee yhteenvedon ostolaskuissa käytetyistä tileistä.',
				description: 'Posting summary purchases description',
			}),
		key: 'postingSummaryPurchases',
		icon: 'description',
	},
]
